import React from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { Typography, Button, Box } from "@mui/material";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import { updateTask } from "../../services/task.service";
import moment from "moment";

const CompleteTaskModal = ({
    open,
    handleClose,
    selectedData,
    refreshData
}) => {
    const dispatch = useDispatch();

    const initialValues = {
        remarks: "",
    };

    const validationSchema = yup.object().shape({
        remarks: yup.string().required("Remarks are required *"),
    });

    const onSubmit = async (values) => {
        try {
            const payload = {
                completedDate: moment().format("YYYY-MM-DD"), // Current date
                remarks: values.remarks,
                status: "2" // Completed status
            };

            const res = await updateTask(selectedData._id, payload);
            dispatch(showToast({ message: "Task completed successfully", type: "success" }));
            handleClose();
            refreshData();
        } catch (error) {
            dispatch(showToast({ message: error?.response?.data?.message || "Something went wrong", type: "error" }));
        }
    };

    return (
        <CrudModal
            title="Complete Task"
            open={open}
            handleClose={handleClose}
            maxWidth="sm"
        >
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({ touched, errors }) => (
                    <div className="formContainer" style={{ height: "fit-content" }}>
                        <Form>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                                        Remarks
                                    </Typography>
                                    <Field
                                        as="textarea"
                                        name="remarks"
                                        className="InputField"
                                        placeholder="Enter Remarks"
                                        style={{ height: "100px", paddingTop: "10px" }}
                                    />
                                    <div className="form-error">
                                        {touched.remarks && errors.remarks ? errors.remarks : null}
                                    </div>
                                </Grid>

                                <Grid size={{ xs: 12 }} mt={2}>
                                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}>
                                        <Button
                                            className="cancelButton"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="addButton"
                                        >
                                            Submit
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    </div>
                )}
            </Formik>
        </CrudModal>
    );
};

export default CompleteTaskModal;
